var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ForumReactions',{attrs:{"show-animation":"","reactions":_vm.mergedReactions,"disabled":_vm.disabled,"disable-reactanimation":_vm.disableReactanimation},on:{"select":_vm.onSelectReaction,"viewReaction":_vm.onViewReaction}})
}
var staticRenderFns = []

export { render, staticRenderFns }